import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createCustomTeamPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        { title: t('customTeam.id'), value: 'id', key: 'id', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.logo'), value: 'logo', key: 'logo', align: 'center', sortable: false, nowrap: true },
        { title: t('customTeam.name'), value: 'name', key: 'name', align: 'start', sortable: true, nowrap: true },
        {
            title: '',
            value: 'uploadLogo',
            key: 'uploadLogo',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 24,
            cellProps: { class: 'pl-0 pr-0' },
        },
        {
            title: t('customTeam.image'),
            value: 'imagePath',
            key: 'imagePath',
            align: 'start',
            sortable: true,
            nowrap: true,
            width: 120,
            minWidth: 125,
            maxWidth: 120,
            cellProps: { class: 'pl-1' },
        },
        { title: t('customTeam.sportId'), value: 'sportId', key: 'sportId', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.countryName'), value: 'countryName', key: 'countryName', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.typeId'), value: 'typeId', key: 'typeId', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.women'), value: 'women', key: 'women', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.youth'), value: 'youth', key: 'youth', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.shortCode'), value: 'shortCode', key: 'shortCode', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.isUseTradeball'), value: 'isUseTradeball', key: 'isUseTradeball', align: 'center', sortable: true, nowrap: true },
        {
            title: t('customTeam.isImageChangedManually'),
            value: 'isImageChangedManually',
            key: 'isImageChangedManually',
            align: 'center',
            sortable: true,
            nowrap: true,
        },
        { title: t('customTeam.gameCount'), value: 'gameCount', key: 'gameCount', align: 'center', sortable: true, nowrap: true },
        { title: t('customTeam.wikiLink'), value: 'wikiLink', key: 'wikiLink', align: 'center', sortable: false, nowrap: true },
        { title: t('customTeam.twitter'), value: 'twitter', key: 'twitter', align: 'center', sortable: false, nowrap: true },
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 48, cellProps: { class: 'pl-0 pr-1' } },
        // { title: t('customTeam.createdAt'), value: 'createdAt', key: 'createdAt', align: 'center', sortable: true, nowrap: true },
        // { title: t('customTeam.updatedAt'), value: 'updatedAt', key: 'updatedAt', align: 'center', sortable: true, nowrap: true },
        // { title: t('customTeam.deletedAt'), value: 'deletedAt', key: 'deletedAt', align: 'center', sortable: true, nowrap: true },
    ];
}
